module.exports = __webpack_public_path__ + "img/allwild.9b97c07c.png";